import { useContext, useEffect, useRef } from 'react';

import { AppContext } from './app-context';
import type { AppState } from './types';

/**
 * App state and the open scope.
 *
 * Every scope value is derived from the route by `AppProvider`, so it is
 * available from the first render and does not depend on the topbar MFE's
 * selectors having mounted. `isLoadingScope` separates "still resolving" from
 * "resolved to nothing", so a consumer always reaches a terminal answer.
 */
export const useApp = (): AppState => {
  const context = useContext(AppContext);
  const prevSeasonRef = useRef(context?.selectedCropSeason);
  const season = context?.selectedCropSeason;

  useEffect(() => {
    prevSeasonRef.current = season;
  }, [season]);

  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }

  return {
    ...context,
    seasonChanged: prevSeasonRef.current !== context.selectedCropSeason
  };
};
